import React, { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { CtaButton } from "@/components/CtaButton";
import { SITE } from "@/constants/testIds";

export default function TestimonialsPage() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.testimonials().then(setItems).catch(() => {});
    }, []);

    return (
        <div>
            <PageHeader
                eyebrow="CLIENT STORIES"
                title="In their own words"
                subtitle="Real outcomes from people who chose to begin. Names appear with permission; some have been shortened."
                breadcrumbs={[{ label: "Home", to: "/" }, { label: "Testimonials" }]}
            />

            <section
                data-testid={SITE.testimonialsCarousel}
                className="py-12 sm:py-16"
            >
                <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                        {items.map((t) => (
                            <figure
                                key={t.id}
                                data-testid={SITE.testimonialCard}
                                className="relative rounded-2xl border border-border/80 bg-white/85 p-6 hover:-translate-y-0.5 transition-transform"
                            >
                                <Quote className="absolute -top-3 -left-3 h-8 w-8 text-terracotta bg-cream rounded-full p-1 border border-border/70" strokeWidth={1.5} />
                                <div className="flex items-center gap-1 text-terracotta">
                                    {Array.from({ length: t.rating || 5 }).map((_, i) => (
                                        <Star
                                            key={`${t.id}-star-${i}`}
                                            className="h-4 w-4 fill-current"
                                            strokeWidth={0}
                                        />
                                    ))}
                                </div>
                                <blockquote className="mt-4 font-display text-lg text-moss leading-snug">
                                    “{t.quote}”
                                </blockquote>
                                <figcaption className="mt-4 text-sm text-foreground/70">
                                    <span className="font-medium text-foreground/90">{t.name}</span>
                                    <span className="text-foreground/60"> · {t.location}</span>
                                    <br />
                                    <span className="text-foreground/55 text-xs">{t.treatment}</span>
                                </figcaption>
                            </figure>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-10">
                <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                    <div className="rounded-3xl bg-moss text-cream p-8 sm:p-10 text-center">
                        <h3 className="font-display text-2xl sm:text-3xl">
                            Your story could be next.
                        </h3>
                        <p className="mt-2 text-cream/85 max-w-xl mx-auto">
                            Most clients see meaningful change within the first month. Let’s talk about your goals.
                        </p>
                        <div className="mt-5 inline-flex">
                            <CtaButton to="/contact" variant="accent">
                                Book your consultation
                            </CtaButton>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
